export default __webpack_public_path__ + "static/media/icon2.30c032ba.svg";